module.exports = __webpack_public_path__ + "img/ex-ecommerce.1d6936aa.jpg";